import React from 'react';
import { useTranslation } from 'react-i18next';
import ModalPortal from './ModalPortal';

interface NoAccountModalProps {
  assistantName: string;
  /** Close and stay on the connect step. */
  onConnectInstead: () => void;
  /** Leave the connect step without an account. */
  onCarryOn: () => void;
}

/**
 * Shown when the user tries to leave the connect step with no account: spells
 * out what the assistant can't do without one and lets them carry on anyway.
 * Connecting is optional, so nothing is collected here.
 */
const NoAccountModal: React.FC<NoAccountModalProps> = ({
  assistantName,
  onConnectInstead,
  onCarryOn,
}) => {
  const { t } = useTranslation();

  return (
    <ModalPortal>
      <div
        className='modal-backdrop-x show'
        onClick={(e) => e.target === e.currentTarget && onConnectInstead()}
      >
        <div
          className='modal-x no-account-modal'
          role='dialog'
          aria-modal='true'
          aria-labelledby='no-account-title'
          data-testid='no-account-modal'
        >
          <div className='no-account-head'>
            <h3 id='no-account-title' className='ob-title'>
              {t('wizard.noAccount.title')}
            </h3>
          </div>
          <div className='no-account-body'>
            <p className='modal-lead'>
              {t('wizard.noAccount.needs', { name: assistantName })}
            </p>
            <p>{t('wizard.noAccount.impact')}</p>
            <p>{t('wizard.noAccount.changeLater')}</p>
            <div className='modal-actions stacked'>
              <button className='btn-secondary' onClick={onCarryOn} autoFocus>
                {t('wizard.noAccount.understandContinue')}
              </button>
              <button className='btn-primary' onClick={onConnectInstead}>
                {t('wizard.noAccount.goBackConnect')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </ModalPortal>
  );
};

export default NoAccountModal;
